import React from "react";
import { API_ORIGIN } from "../../axios";
import LinkIcon from "../ui/LinkIcon";
import ImageLinkGrid from "../ImageLinkGrid";
import { groupLinks } from "../../utils/linkImage";

const PhonePreview = ({
  activeTheme,
  themeSurface,
  imgchange,
  havepic,
  picture,
  showpicture,
  id,
  bio,
  inputFields,
  cover,
  t,
}) => (
  <div className="relative mx-auto" style={{ width: "100%", aspectRatio: "1350 / 2760" }}>
    <div
      className="preview-no-scrollbar absolute overflow-y-auto overflow-x-hidden bg-white"
      style={{
        left: "5.3%",
        top: "2.5%",
        width: "89.3%",
        height: "95%",
        borderRadius: "9% / 4.4%",
        zIndex: 1,
      }}
    >
      <div
        className="relative min-h-full px-4 pt-20 pb-6 text-center transition-all duration-500"
        style={{
          background: activeTheme.gradient,
          color: activeTheme.text,
          fontFamily: activeTheme.font,
        }}
      >
        {cover && (
          // Mask fades the image out so the theme gradient shows through, same as the public page.
          <div
            className="absolute top-0 inset-x-0 overflow-hidden pointer-events-none"
            style={{
              // Matches the real page's mask height (h-72 = 288px) relative to a ~393px-wide phone,
              // scaled to whatever width this mockup is rendered at, so the crop/zoom stays consistent.
              aspectRatio: "393 / 288",
              WebkitMaskImage: "linear-gradient(to bottom, #000 0%, #000 35%, transparent 100%)",
              maskImage: "linear-gradient(to bottom, #000 0%, #000 35%, transparent 100%)",
            }}
          >
            <img
              key={cover}
              className="w-full h-full object-cover"
              alt=""
              src={cover}
              onError={(e) => {
                e.currentTarget.style.display = "none";
              }}
            />
          </div>
        )}
        <div
          className="relative mx-auto w-20 h-20 rounded-full overflow-hidden shadow-md transition-all duration-500"
          style={{
            border: `4px solid ${activeTheme.isDark ? "rgba(255,255,255,0.85)" : "#ffffff"
              }`,
          }}
        >
          {!imgchange ? (
            havepic ? (
              <img
                className="w-full h-full object-cover"
                alt={t("Avatar")}
                src={`${API_ORIGIN}/profile/` + picture}
              />
            ) : (
              <img
                className="w-full h-full object-cover"
                alt={t("Avatar")}
                src={`${process.env.PUBLIC_URL}/images/pp.png`}
              />
            )
          ) : (
            <img className="w-full h-full object-cover" alt={t("Avatar")} src={showpicture} />
          )}
        </div>
        <p className="relative mt-2 text-sm font-semibold truncate" style={{ color: activeTheme.text }}>
          @{id}
        </p>
        {bio ? (
          <p
            className="relative mt-1 text-[11px] leading-snug px-1"
            style={{ color: activeTheme.text, opacity: themeSurface.mutedOpacity }}
          >
            {bio}
          </p>
        ) : null}
        <div className="relative mt-5 space-y-2 text-left">
          {groupLinks(inputFields.filter((f) => f.social_name || f.link || f.image_url)).map(
            (block) =>
              block.kind === "images" ? (
                <ImageLinkGrid
                  key={"images-" + block.entries[0].index}
                  items={block.entries}
                  themeSurface={themeSurface}
                  preview
                />
              ) : (
                <div
                  key={block.index}
                  className="flex items-center justify-between gap-2 px-3 py-2 transition-all duration-500"
                  style={themeSurface.card}
                >
                  <span className="text-[11px] font-medium truncate" style={{ color: activeTheme.text }}>
                    {block.item.social_name || t("link titel")}
                  </span>
                  <span
                    className="w-6 h-6 flex items-center justify-center shrink-0 transition-all duration-500"
                    style={themeSurface.iconWrap}
                  >
                    <LinkIcon
                      value={block.item.image || "fa-link text-slate-300"}
                      color={themeSurface.uniformIcons ? themeSurface.iconColor : undefined}
                      onBackground={themeSurface.iconWrap.background}
                      className="text-xs"
                    />
                  </span>
                </div>
              )
          )}
        </div>
      </div>
    </div>
    <img
      src={`${process.env.PUBLIC_URL}/images/bezels/iphone-18-pro-black.webp`}
      alt={t("iPhone preview frame")}
      className="absolute inset-0 w-full h-full pointer-events-none select-none"
      style={{ zIndex: 2 }}
      draggable={false}
    />
  </div>
);

export default PhonePreview;
